<!-- [ngClass]="(panelStatus) ? 'full-page' : ''" -->
<div class="row">
  <div class="container">
    <div
      class="col-xs-12 col-sm-12 col-lg-12 px-0 d-flex align-items-center tp"
    >
      <h1 class="m-0">Dashboard</h1>
      <a [href]="FileLink()" target="_blank" download>Download Sample File</a>
    </div>
    <div class="tphead mb-5">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 srch_wrapper pr-0">
        <div class="ct ml-4">
          <h5>Score</h5>
          <input
            type="number"
            min="75"
            max="100"
            name="score"
            id="score"
            (keypress)="numberOnly($event)"
            [(ngModel)]="score"
            style="width: 75px"
          />
        </div>
        <div class="ct ml-4">
          <h5>Is Exact</h5>
          <!-- <input type="checkbox" id="exact" name="exact" [(ngModel)]="is_exact" /> -->
          <select
            class="form-select"
            aria-label="Select Value"
            [(ngModel)]="is_exact"
          >
            <option value="false">No</option>
            <option selected value="true">Yes</option>
          </select>
        </div>
        <div class="ct ml-4">
          <h5>Result Count</h5>
          <input
            type="number"
            min="1"
            name="result_count"
            id="result_count"
            (keypress)="numberOnly($event)"
            [(ngModel)]="result_count"
            style="width: 75px"
          />
        </div>
        <div class="ct d-flex flex-column ml-4">
          <h5>Upload</h5>
          <div class="tab-slider--container" [ngSwitch]="viewMode">
            <div
              id="tab1"
              class="tab-slider--body"
              *ngSwitchCase="'tab1'"
              (dragover)="OnDragOver($event)"
              (drop)="onDrop($event)"
              (dragleave)="onDragLeave($event)"
            >
              <label for="file-upload" class="custom-file-upload">
                <i class="fa fa-cloud-upload"></i
                ><b *ngIf="!files.length">
                  Click to upload or drag and drop file here.
                </b>
                <div
                  (dragover)="OnDragOver($event)"
                  (drop)="onDrop($event)"
                  (dragleave)="onDragLeave($event)"
                ></div>
                <!-- <div class="overlay-drag" *ngIf="isDragged"></div> -->
                <div
                  [formGroup]="attachmentForm"
                  *ngIf="files && files.length"
                  class="w-100"
                >
                  <div
                    *ngFor="
                      let attachment of GetControls('attachments');
                      let i = index
                    "
                    formArrayName="attachments"
                    class="w-100"
                  >
                    <div [formGroupName]="i" class="w-100">
                      <div class="innerUpload">
                        <div class="iuinfo">
                          <p>
                            {{ attachment.get("name").value }}
                          </p>
                          <p>
                            {{
                              FileSizeConverter(attachment.get("size").value)
                            }}
                          </p>
                        </div>
                        <!-- <img src="assets/close.png" class="img-fluid"/> -->
                        <button (click)="RemoveFile($event)">
                          <img
                            src="assets/close.png"
                            style="cursor: pointer"
                            class="img-fluid"
                            style="max-width: 20px; height: auto"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </label>
              <input
                id="file-upload"
                type="file"
                (change)="FileSelected()"
                #fileInput
                accept=".tsv"
                autocomplete="off"
              />
              <button (click)="Upload()" [disabled]="!fileValid">
                <img src="assets/upload.png" class="img-fluid" />
              </button>
            </div>
            <small
              style="color: #d5a762"
              *ngIf="
                viewMode == 'tab2' &&
                !jobCreated &&
                fileError &&
                !fileError.length
              "
              >* Only CSV (Encoding of the file should be 'UTF-8') file format
              accepted.</small
            >
            <div
              style="border: 1px solid rgba(255, 0, 0, 0.25); z-index: 9"
              class="alert alert-danger"
              *ngIf="fileError && fileError.length && files && files.length"
            >
              <ng-template ngFor [ngForOf]="fileError" let-error>
                * {{ error }} <br />
              </ng-template>
            </div>

            <div class="alert alert-success" *ngIf="jobCreated">
              {{ jobCreated }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main c1" *ngIf="!dataErrorMessage">
      <div class="refresh-icon-container">
        <button class="refresh-button" (click)="getAllLogData()">
          <svg
            width="50px"
            height="50px"
            viewBox="0 0 50 50"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25 38c-7.2 0-13-5.8-13-13 0-3.2 1.2-6.2 3.3-8.6l1.5 1.3C15 19.7 14 22.3 14 25c0 6.1 4.9 11 11 11 1.6 0 3.1-.3 4.6-1l.8 1.8c-1.7.8-3.5 1.2-5.4 1.2z"
            />
            <path
              d="M34.7 33.7l-1.5-1.3c1.8-2 2.8-4.6 2.8-7.3 0-6.1-4.9-11-11-11-1.6 0-3.1.3-4.6 1l-.8-1.8c1.7-.8 3.5-1.2 5.4-1.2 7.2 0 13 5.8 13 13 0 3.1-1.2 6.2-3.3 8.6z"
            />
            <path d="M18 24h-2v-6h-6v-2h8z" />
            <path d="M40 34h-8v-8h2v6h6z" />
          </svg>
        </button>
      </div>
      <div class="card">
        <div class="card-header">
          <div class="title d-flex align-items-center">
            List of Requested Batch
          </div>
          <div class="srch" *ngIf="!loading && logData && logData.length">
            <input
              type="search"
              placeholder="Search"
              [(ngModel)]="searchValue"
              autocomplete="off"
            />
            <div class="clear" (click)="RemoveSearch()" *ngIf="searchValue">
              <img
                src="assets/close.png"
                class="img-fluid"
                style="max-width: 20px; cursor: pointer"
              />
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="ct table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th
                    scope="col"
                    [class.active]="order === 'id'"
                    (click)="setOrder('id')"
                  >
                    ID
                    <span
                      [hidden]="reverse"
                      class="fa fa-arrow-down"
                      title="Ascending Order"
                    ></span>
                    <span
                      [hidden]="!reverse"
                      class="fa fa-arrow-up"
                      title="Descending Order"
                    ></span>
                  </th>

                  <th
                    scope="col"
                    [class.active]="order === 'name'"
                    (click)="setOrder('name')"
                  >
                    Name
                    <span
                      [hidden]="reverse"
                      class="fa fa-arrow-down"
                      title="Ascending Order"
                    ></span>
                    <span
                      [hidden]="!reverse"
                      class="fa fa-arrow-up"
                      title="Descending Order"
                    ></span>
                  </th>

                  <!-- <th
                    scope="col"
                    [class.active]="order === 'query_param'"
                    (click)="setOrder('query_param')"
                  >
                    Query

                    <span
                      [hidden]="reverse"
                      class="fa fa-arrow-down"
                      title="Ascending Order"
                    ></span>
                    <span
                      [hidden]="!reverse"
                      class="fa fa-arrow-up"
                      title="Descending Order"
                    ></span>
                  </th> -->

                  <th
                    scope="col"
                    [class.active]="order === 'requested_by_username'"
                    (click)="setOrder('requested_by_username')"
                  >
                    Requested By

                    <span
                      [hidden]="reverse"
                      class="fa fa-arrow-down"
                      title="Ascending Order"
                    ></span>
                    <span
                      [hidden]="!reverse"
                      class="fa fa-arrow-up"
                      title="Descending Order"
                    ></span>
                  </th>
                  <th
                    scope="col"
                    [class.active]="order === 'requested_on'"
                    (click)="setOrder('requested_on')"
                  >
                    Created

                    <span
                      [hidden]="reverse"
                      class="fa fa-arrow-down"
                      title="Ascending Order"
                    ></span>
                    <span
                      [hidden]="!reverse"
                      class="fa fa-arrow-up"
                      title="Descending Order"
                    ></span>
                  </th>
                  <th
                    scope="col"
                    [class.active]="order === 'completed_on'"
                    (click)="setOrder('completed_on')"
                  >
                    Completed

                    <span
                      [hidden]="reverse"
                      class="fa fa-arrow-down"
                      title="Ascending Order"
                    ></span>
                    <span
                      [hidden]="!reverse"
                      class="fa fa-arrow-up"
                      title="Descending Order"
                    ></span>
                  </th>
                  <th
                    scope="col"
                    [class.active]="order === 'file'"
                    (click)="setOrder('file')"
                  >
                    File

                    <span
                      [hidden]="reverse"
                      class="fa fa-arrow-down"
                      title="Ascending Order"
                    ></span>
                    <span
                      [hidden]="!reverse"
                      class="fa fa-arrow-up"
                      title="Descending Order"
                    ></span>
                  </th>
                  <th
                    scope="col"
                    [class.active]="order === 'status'"
                    (click)="setOrder('status')"
                  >
                    Status

                    <span
                      [hidden]="reverse"
                      class="fa fa-arrow-down"
                      title="Ascending Order"
                    ></span>
                    <span
                      [hidden]="!reverse"
                      class="fa fa-arrow-up"
                      title="Descending Order"
                    ></span>
                  </th>
                </tr>
              </thead>
              <tbody *ngIf="!loading && logData && logData.length">
                <tr
                  *ngFor="
                    let log of logData
                      | filter
                        : searchValue
                        : [
                            'id',
                            'name',
                            'requested_by_username',
                            'upload_file_name'
                          ]
                        : false
                      | orderBy : order : reverse : caseInsensitive
                      | paginate
                        : { itemsPerPage: 10, currentPage: pageControl }
                  "
                >
                  <th scope="row">{{ log.id }}</th>

                  <!-- <td>
                    {{
                      log.query_param
                        ? QueryManipulation(log.query_param)
                        : "Not Available"
                    }}
                  </td> -->

                  <td>
                    <span [title]="log.name ? log.name : 'Not Available'">
                      {{
                        truncateString(
                          log.name ? log.name : "Not Available",
                          15
                        )
                      }}
                    </span>
                  </td>

                  <td>
                    {{
                      log.requested_by_username
                        ? log.requested_by_username
                        : "Not Available"
                    }}
                  </td>

                  <td>
                    <span>
                      {{
                        log.created_on
                          ? (log.created_on | date : "mediumDate")
                          : "-"
                      }}
                      <br />
                      {{
                        log.created_on
                          ? (log.created_on | date : "shortTime")
                          : "-"
                      }}
                    </span>
                  </td>

                  <td>
                    <span>
                      {{
                        log.completion_date
                          ? (log.completion_date | date : "mediumDate")
                          : "-"
                      }}
                      <br />
                      {{
                        log.completion_date
                          ? (log.completion_date | date : "shortTime")
                          : "-"
                      }}
                    </span>

                    <!-- {{
                      log.completion_date
                        ? log.completion_date | date: "mediumDate" : '-'
                      }} |
                        {{ log.completion_date ? log.completion_date | date: "shortTime"  : "-"
                    }} -->
                  </td>

                  <td>
                    <span
                      [title]="
                        log.upload_file_name
                          ? TrimFileName(log.upload_file_name)
                          : 'Not Available'
                      "
                    >
                      {{
                        truncateString(
                          log.upload_file_name
                            ? TrimFileName(log.upload_file_name)
                            : "Not Available",
                          15
                        )
                      }}</span
                    >
                  </td>

                  <td align="center">
                    <div
                      class="queued"
                      *ngIf="log.status.toLowerCase() == 'queue'"
                    >
                      QUEUE
                    </div>

                    <div class="queued" *ngIf="log.status == 'In Progress'">
                      IN-PROGRESS
                    </div>

                    <div
                      class="queued"
                      *ngIf="log.status.toLowerCase() == 'pending'"
                    >
                      PENDING
                    </div>

                    <div
                      class="queued"
                      *ngIf="log.status.toLowerCase() == 'created'"
                    >
                      CREATED
                    </div>

                    <div
                      class="failed"
                      *ngIf="log.status.toLowerCase() == 'failed'"
                      [tooltip]="log.remarks ? log.remarks : ''"
                      placement="top"
                    >
                      FAILED
                    </div>

                    <img
                      src="assets/download.png"
                      (click)="DownloadFile(log.download_file_name)"
                      [title]="
                        log.download_file_name
                          ? TrimFileName(log.download_file_name)
                          : 'Not Available'
                      "
                      style="max-width: 20px; cursor: pointer"
                      class="img-fluid"
                      *ngIf="log.status.toLowerCase() == 'completed'"
                    />
                  </td>
                </tr>
              </tbody>
              <tfoot *ngIf="!loading && logData && !logData.length">
                <tr>
                  <td colspan="7">
                    <div>
                      <div class="alert alert-danger text-center">
                        <h4 class="m-0">
                          <b style="color: red"> No data Available</b>
                        </h4>
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="card-footer text-center">
          <pagination-controls
            maxSize="7"
            directionLinks="true"
            maxSize="9"
            autoHide="true"
            responsive="true"
            previousLabel="Previous"
            nextLabel="Next"
            screenReaderPaginationLabel="Pagination"
            screenReaderPageLabel="page"
            (pageChange)="onPageChange($event)"
            (pageBoundsCorrection)="pageControl = $event"
          >
          </pagination-controls>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="dataErrorMessage">
      <div class="col text-center">
        <div class="card mb-5 alert alert-danger">
          <div class="card-body pl-5">
            <h4 class="m-0">
              <b style="color: red">
                Error in getting data! Refresh or re-login please..</b
              >
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#fff" type="square-jelly-box" [fullScreen]="true">
  <p style="color: white">
    {{ downloading ? "Downloading.." : uploading ? "Uploading in progress" : "Loading.." }}
  </p>
</ngx-spinner> -->
<ngx-bootstrap-spinner
  size="default"
  color="white"
  type="grow"
  [fullScreen]="true"
  [loadingText]="
    downloading ? 'Downloading..' : uploading ? 'Uploading..' : 'Loading..'
  "
>
  <!-- <ngx-bootstrap-spinner size="default" color="white" type="grow" [fullScreen]="true" [loadingText]="(downloading ? 'Downloading..' : 'Loading..')"> -->
  <!-- <ngx-bootstrap-spinner size="default" color="white" type="grow" [fullScreen]="true" [loadingText]="'Loading..'"> -->
</ngx-bootstrap-spinner>
